module.exports = __webpack_public_path__ + "img/small-1.6bcdbfd4.jpg";